import { gql } from "@apollo/client";
const REFRESH_AUTH_TOKEN = gql `
  query refreshAuthToken($token: String!) {
    refreshAuthToken(token: $token) {
      access_token
      expires_in
    }
  }
`;
export default REFRESH_AUTH_TOKEN;
